import moment from "moment";
import * as XLSX from "xlsx";

export const downloadExcel = (fileName, columns, data) => {
  // Excel cell content limit
  const MAX_CELL_LENGTH = 32767;
  
  // Helper function to truncate cell content if it exceeds Excel's limit
  const truncateIfNeeded = (value) => {
    if (value == null) return value;
    
    const strValue = String(value);
    if (strValue.length > MAX_CELL_LENGTH) {
      return strValue.substring(0, MAX_CELL_LENGTH - 50) + "\n\n... (truncated due to Excel cell limit)";
    }
    return value;
  };
  
  // Prepare data for xlsx
  const worksheetData = [];
  
  // Add header row
  const headerRow = columns.map(col => col.header || col.key);
  worksheetData.push(headerRow);
  
  // Add data rows
  data.forEach((row) => {
    const rowData = [];
    columns.forEach((col) => {
      let cellValue;
      if (col.format && col.format === "date") {
        cellValue = moment(row[col.key]).format("DD MMM YYYY hh:mm a");
      } else {
        cellValue = row[col.key];
      }
      // Truncate if needed to prevent Excel errors
      rowData.push(truncateIfNeeded(cellValue));
    });
    worksheetData.push(rowData);
  });

  // Create workbook and worksheet
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  
  // Set column widths
  const columnWidths = columns.map(col => ({ wch: col.width || 15 }));
  worksheet['!cols'] = columnWidths;
  
  // Apply styling to header row (first row)
  const headerRange = XLSX.utils.decode_range(worksheet['!ref']);
  for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
    const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
    if (!worksheet[cellAddress]) continue;
    
    // Set header cell style
    worksheet[cellAddress].s = {
      font: { bold: true },
      fill: { fgColor: { rgb: "F2F2F2" } },
      border: {
        top: { style: "thin", color: { rgb: "A6A6A6" } },
        left: { style: "thin", color: { rgb: "A6A6A6" } },
        bottom: { style: "thin", color: { rgb: "A6A6A6" } },
        right: { style: "thin", color: { rgb: "A6A6A6" } }
      }
    };
  }
  
  // Add worksheet to workbook
  // Excel sheet names cannot exceed 31 characters
  const sheetName = fileName.length > 31 ? fileName.substring(0, 31) : fileName;
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  
  // Generate Excel file and trigger download
  try {
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = `${fileName}.xlsx`;
    anchor.click();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Error generating Excel file:", err);
  }
};
